import { useEffect, useRef } from "react";

// Periodically re-runs `callback` so views stay in sync across staff & admin.
// Also refetches when the tab regains focus / becomes visible, and pauses while hidden.
export function useAutoRefresh(callback, intervalMs = 20000) {
  const cbRef = useRef(callback);
  cbRef.current = callback;
  useEffect(() => {
    const run = () => { if (!document.hidden) cbRef.current && cbRef.current(); };
    const id = setInterval(run, intervalMs);
    window.addEventListener("focus", run);
    document.addEventListener("visibilitychange", run);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", run);
      document.removeEventListener("visibilitychange", run);
    };
  }, [intervalMs]);
}
